import { LOGIN_METHOD, LoginMethod } from '@/api';

const METHOD_ORDER = [LOGIN_METHOD.EMAIL_MAGIC_LINK, LOGIN_METHOD.OIDC, LOGIN_METHOD.NOSTR];

/** Shown until the server list arrives, and when fetching it fails. */
export const ALWAYS_ON_METHODS: readonly LoginMethod[] = [
  LoginMethod.EmailMagicLink,
  LoginMethod.Nostr,
];

/** Server methods intersected with the optional override, in display order. */
export function visibleMethods(
  server: readonly LoginMethod[],
  override?: readonly LOGIN_METHOD[]
): LOGIN_METHOD[] {
  return METHOD_ORDER.filter(
    (m) => server.some((s) => (s as string) === m) && (!override || override.includes(m))
  );
}

/** The method rendered with the filled primary style. */
export function primaryMethod(methods: readonly LOGIN_METHOD[]): LOGIN_METHOD | undefined {
  return methods[0];
}
